/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLanguageTranslations200ResponseItemsInnerName
 */
export interface GetLanguageTranslations200ResponseItemsInnerName {
    /**
     * 
     * @type {string}
     * @memberof GetLanguageTranslations200ResponseItemsInnerName
     */
    original: string;
    /**
     * 
     * @type {string}
     * @memberof GetLanguageTranslations200ResponseItemsInnerName
     */
    translation?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetLanguageTranslations200ResponseItemsInnerName
     */
    autoTranslated?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetLanguageTranslations200ResponseItemsInnerName
     */
    stale?: boolean;
}

/**
 * Check if a given object implements the GetLanguageTranslations200ResponseItemsInnerName interface.
 */
export function instanceOfGetLanguageTranslations200ResponseItemsInnerName(value: object): value is GetLanguageTranslations200ResponseItemsInnerName {
    if (!('original' in value) || value['original'] === undefined) return false;
    return true;
}

export function GetLanguageTranslations200ResponseItemsInnerNameFromJSON(json: any): GetLanguageTranslations200ResponseItemsInnerName {
    return GetLanguageTranslations200ResponseItemsInnerNameFromJSONTyped(json, false);
}

export function GetLanguageTranslations200ResponseItemsInnerNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLanguageTranslations200ResponseItemsInnerName {
    if (json == null) {
        return json;
    }
    return {
        
        'original': json['original'],
        'translation': json['translation'] == null ? undefined : json['translation'],
        'autoTranslated': json['autoTranslated'] == null ? undefined : json['autoTranslated'],
        'stale': json['stale'] == null ? undefined : json['stale'],
    };
}

export function GetLanguageTranslations200ResponseItemsInnerNameToJSON(json: any): GetLanguageTranslations200ResponseItemsInnerName {
    return GetLanguageTranslations200ResponseItemsInnerNameToJSONTyped(json, false);
}

export function GetLanguageTranslations200ResponseItemsInnerNameToJSONTyped(value?: GetLanguageTranslations200ResponseItemsInnerName | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'original': value['original'],
        'translation': value['translation'],
        'autoTranslated': value['autoTranslated'],
        'stale': value['stale'],
    };
}

